/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

import React, { useRef } from 'react';
import { useOnClickOutside } from 'helpers';
import CountryDropdown from './CountryDropdown';

const CountryDropdownContainer = ({
    selectedItem,
    showDropdown,
    setShowDropdown,
    callback
}) => {
    const dropdownRef = useRef();
    useOnClickOutside(dropdownRef, () => setShowDropdown(false));

    return (
        <CountryDropdown
            selectedItem={selectedItem}
            showDropdown={showDropdown}
            setShowDropdown={setShowDropdown}
            dropdownRef={dropdownRef}
            callback={callback}
        />
    )
};

export default CountryDropdownContainer;
